import { AnalyticsConfig } from '../analytics';

const googleAnalyticsConfig = {
  prod: 'G-8M3NPXWBF4',
  preprod: 'G-P1346MH4G0',
  dev: 'G-P1346MH4G0',
} as AnalyticsConfig;

export default googleAnalyticsConfig;
